import { render, staticRenderFns } from "./ProAnchor.vue?vue&type=template&id=4d67abe7&"
import script from "./ProAnchor.vue?vue&type=script&lang=js&"
export * from "./ProAnchor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports